import { render } from "./BaseImg.vue?vue&type=template&id=5aa18c68&scoped=true"
const script = {}

import "./BaseImg.vue?vue&type=style&index=0&id=5aa18c68&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa18c68"]])

export default __exports__